<template>
   <div class="list">
		<div class="pt40">
			<div class="m-news-list" v-if="newsList.length > 0">
				<dl v-for="(item,index) in newsList" :key="index">
					<dt class="fl">
						<img :src="item.imgUrl" alt="" width="320" height="160">
					</dt>
					<dd class="fl">
						<h3>
                            <router-link :to="{path:'/news/detail',query:{id:item.news_id}}">{{item.title}}</router-link>
                        </h3>
						<p class="m-news-info">
							<router-link :to="{path:'/news/detail',query:{id:item.news_id}}">{{item.descriptions}}</router-link>
						</p>
						<div class="m-news-foot">
							<span class="fl">{{item.publishAt | dateformat}}</span>
                            <router-link class="fr" :to="{path:'/news/detail',query:{id:item.news_id}}">查看更多</router-link>
							<!-- <a class="fr" href="#">查看更多</a> -->
						</div>
					</dd>
				</dl>
				<div class="tac mb50">
					<page :data-num = "dataNum" :pageSize="pageSize" :visiblepage="visiblepage" v-on:change-page="changePage"></page>
				</div>
			</div>
			<div class="m-no-data mb50" v-else>
				<div class="tac f24">
					暂无数据
				</div>				
			</div>
		</div>
   </div>
</template>
<style scoped lang="scss">
.m-news-list {
	overflow: hidden;
	dl {
		width: 1100px;
		height: 160px;
		margin-bottom: 40px;
	}
	dt {
		width: 320px;
		height: 160px;
		margin-right: 50px;
	}
  dd {
    width: 630px;
    height: 140px;
    color: #666;
    padding: 10px 0;
    p {
		font-size: 14px;
		line-height: 24px;
    }
    h3 {
		font-size: 18px;
		line-height: 26px;
		font-family: "PingFangSC-Medium";
		font-weight: normal;
		margin-bottom: 10px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		a{
			color: #333;
		}
    }
    .m-news-info {
		height: 72px;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		a{
			color: #333;
		}
    }
    .m-news-foot {
      overflow: hidden;
      font-size: 14px;
      height: 24px;
      line-height: 24px;
      margin-top: 10px;
      a {
        color: #4a90e2;
        text-decoration: underline;
      }
    }
  }
}
</style>
<script>
import Page from "@/components/Page.vue";
export default {
  name: "list",
  components: {
    Page
  },
  data: function() {
    return {
      newsList: [],
      current: 0,
      dataNum: 0,
      pageSize: 10,
      visiblepage: 10,
      //pagedata:[0,1,2,3,4,5,6,7,8,9],
      currentPage: 1
    };
  },
  // computed:{
  // 	currentList:function(){
  // 		this.pagedata = this.newsList;
  // 		var p = [];
  // 		for(var i = 0,l = this.pagedata.length;i < l;i++){
  // 			p[i] = this.pagedata[i];
  // 		}
  // 		return p.splice((this.currentPage-1) * this.pageSize, this.pageSize);
  // 	}
  // },
  methods: {
    getNewsList: function() {
        this.axios.get(window.API_HOST+"/cms/cmsapi", {
            params: {
                type: 1,
                p: this.currentPage,
                pageSize: this.pageSize,
                platformId: 1
            }
        })
        .then(
            res => {
                //console.log(res);
                let resdata = res.data;
                if (resdata.message.code == 0) {
                this.newsList = resdata.data.data;
                this.dataNum = resdata.count;
                this.$router.push({
                    path: "/news",
                    query: {
                    p: this.currentPage
                    }
                });
                }
            },
            res => {
                console.log(res);
            }
        );
    },
    changePage: function(current) {
      this.currentPage = current;
    }
  },
  created: function() {
    this.getNewsList();
  },
  watch: {
    currentPage: function() {
      this.getNewsList();
    }
  }
};
</script>